// src/utils/reminderUtils.js

/**
 * คืนค่า ISO String (YYYY-MM-DDTHH:mm) สำหรับรอบถัดไปของ reminder ตาม repeatType
 * - "everyday"        → ทุกวัน เวลาเดิม
 * - "specificDays"    → วันถัดไปในสัปดาห์ที่เลือก เวลาเดิม
 * - "dateRange"       → วันถัดไปในช่วง range (สิ้นสุดเมื่อเลย range)
 * - "specificDate"    → เตือนแค่ครั้งเดียว
 * คืนค่า null ถ้าไม่ควรสร้างรอบใหม่ (หมดช่วง, หรือไม่มีค่า)
 */
export function getNextReminderTime(reminder) {
    if (!reminder) return null;
  
    // --- ทุกวัน ---
    if (reminder.repeatType === "everyday") {
      // reminder.time: "08:00"
      const [hh, mm] = reminder.time.split(":");
      if (hh === undefined || mm === undefined) return null;
      const now = new Date();
      now.setDate(now.getDate() + 1);
      now.setHours(Number(hh), Number(mm), 0, 0);
      return toInputDatetimeLocal(now);
    }
  
    // --- เฉพาะวันในสัปดาห์ ---
    if (reminder.repeatType === "specificDays") {
      // reminder.time: "08:00"
      const days = Array.isArray(reminder.repeatConfig?.days)
        ? reminder.repeatConfig.days.map(Number).filter(d => d >= 0 && d <= 6)
        : [];
      if (!days.length) return null;
      const [hh, mm] = reminder.time.split(":");
      if (hh === undefined || mm === undefined) return null;
      const now = new Date();
      let today = now.getDay();
      let minDiff = 8;
      for (let d of days) {
        let diff = (d - today + 7) % 7;
        if (diff === 0) diff = 7;
        if (diff < minDiff) minDiff = diff;
      }
      now.setDate(now.getDate() + minDiff);
      now.setHours(Number(hh), Number(mm), 0, 0);
      return toInputDatetimeLocal(now);
    }
  
    // --- ช่วงวันที่ ---
    if (reminder.repeatType === "dateRange") {
      // reminder.time: "YYYY-MM-DDTHH:mm"
      const end = reminder.repeatConfig?.end; // "YYYY-MM-DD"
      let base = new Date(reminder.time);
      if (isNaN(base)) return null;
      base.setDate(base.getDate() + 1);
      // ห้ามเกิน end
      if (end && base.toISOString().slice(0, 10) > end) return null;
      return toInputDatetimeLocal(base);
    }
  
    // --- วันเดียว ---
    if (reminder.repeatType === "specificDate") {
      // เตือนแค่ครั้งเดียว
      return null;
    }
  
    return null;
  }
  
  /**
   * แปลง Date object เป็น "YYYY-MM-DDTHH:mm" (local time)
   * ใช้กับ input[type="datetime-local"]
   */
  export function toInputDatetimeLocal(date) {
    if (!(date instanceof Date) || isNaN(date)) return "";
    const pad = n => n.toString().padStart(2, '0');
    const yyyy = date.getFullYear();
    const MM = pad(date.getMonth() + 1);
    const dd = pad(date.getDate());
    const hh = pad(date.getHours());
    const mm = pad(date.getMinutes());
    return `${yyyy}-${MM}-${dd}T${hh}:${mm}`;
  }